import {RefugeImage} from "~/types/RefugeImage";

export interface NavDetails {
    header: string;
    links: string[];

    imageHeaders: string[];
    imageLinks: string[];
    imageRedirects: string[];

    leftList: string[];
    rightList: RefugeImage[];

    secondLeftList?: string[];
    secondHeader?: string;
    secondListLinks?: string[];
}

export const EmptyDetails: NavDetails = {
    header: "",
    links: [],
    leftList: [],
    rightList: [],
    imageHeaders: [],
    imageLinks: [],
    imageRedirects: [],
};

export const TheRefugeDetails: NavDetails = {
    header: "About Us",
    leftList: ["Our Story", "Booking", "How to get here", "faqTitle", "liveWebCams"],
    links: ["/refuge/story", "/refuge/booking", "/refuge/approach", "/refuge/faq", "/refuge/cameras"],
    rightList: [],
    imageHeaders: ["Photos", "Videos", "webCams"],
    imageLinks: [
        "https://res.cloudinary.com/dlct0dnwt/image/upload/v1684614474/refuge/outside/main_yjac0p.jpg",
        "https://res.cloudinary.com/dlct0dnwt/image/upload/v1684614475/refuge/outside/outside_15_v9wdcw.jpg",
        "https://res.cloudinary.com/dlct0dnwt/image/upload/v1743292001/refuge/2025/3PMA7282_frwz4z.jpg"
    ],
    imageRedirects: ["/refuge/photos", "/refuge/videos", "/refuge/cameras"],
};

export const ServicesDetails: NavDetails = {
    header: "Accommodation",
    leftList: ["Overnight Stay", "Camping", "Common Area", "Kitchen"],
    links: ["/services/accommodation", "/services/accommodation#camping", "/services/accommodation#common-area", "/services/accommodation#kitchen"],
    rightList: [],
    imageHeaders: ["Menu", "Accommodation"],
    imageLinks: [
        "https://res.cloudinary.com/dlct0dnwt/image/upload/v1684618456/refuge/stock/food_jprilv.jpg",
        "https://res.cloudinary.com/dlct0dnwt/image/upload/v1684614498/refuge/inside/sleepingArea_2_bbkixo.jpg"
    ],
    imageRedirects: ["/services/menu", "/services/accommodation"],
    secondHeader: "Food & Drink",
    secondLeftList: ["Menu"],
    secondListLinks: ["/services/menu"],
};

export const ActivitiesDetails: NavDetails = {
    header: "Hiking",
    leftList: ["Hiking Trails"],
    links: ["/activities/hiking-trails"],
    rightList: [],
    imageHeaders: ["Hiking", "Alpine"],
    imageLinks: [
        "https://res.cloudinary.com/dlct0dnwt/image/upload/v1684614486/refuge/activities/hiking_2_xipvwv.jpg",
        "https://res.cloudinary.com/dlct0dnwt/image/upload/v1684614489/refuge/activities/icecClimbing_5_c7zg7x.jpg"
    ],
    imageRedirects: ["/activities/hiking-trails", "/activities/alpine"],
    secondHeader: "Alpine",
    secondLeftList: ["Winter School", "Ice Climbing", "Alpine Skiing"],
    secondListLinks: ["/activities/alpine", "/activities/alpine#ice-climbing", "/activities/alpine#skiing"]
};
